import { t } from "ttag";

import {
  AdminNavItem,
  type AdminNavItemProps,
  AdminNavWrapper,
} from "metabase/admin/components/AdminNav";
import { shouldNudgeToPro } from "metabase/admin/people/selectors";
import { UpsellSSO } from "metabase/admin/upsells";
import { color } from "metabase/lib/colors";
import { useSelector } from "metabase/lib/redux";
import { getLocation } from "metabase/selectors/routing";
import { Stack } from "metabase/ui";

export function PeopleNav({ isPeoplePage = false }: { isPeoplePage?: boolean }) {
  const shouldNudge = useSelector(shouldNudgeToPro) as boolean;

  return (
    <AdminNavWrapper isPeoplePage={isPeoplePage} justify="space-between" style={{ backgroundColor: color("admin-background"), borderRadius: "999px" }}>
      <Stack
        style={{
          display: "flex", flexDirection: "row", borderRadius: "999px", backgroundColor: "#f1f1f1", padding: "0", gap: "0"}}
        // gap="xs"
      >
        <PeopleNavItem
          styles={{
            root: { marginBottom: 0, textAlign: "center" },
            label: { width: "100%", textAlign: "center" },
          }}
          mb={"0"}
          path="/admin/people"
          data-testid="nav-item"
          label={t`People`}
          icon="person"
        />
        <PeopleNavItem
          styles={{
            root: { marginBottom: 0, textAlign: "center" },
            label: { width: "100%", textAlign: "center" },
          }}
          mb={"0"}
          path="/admin/people/groups"
          data-testid="nav-item"
          label={t`Groups`}
          icon="group"
        />
      </Stack>
      {shouldNudge && <UpsellSSO location="people-groups-settings" />}
    </AdminNavWrapper>
  );
}

const PeopleNavItem = (props: AdminNavItemProps) => {
  const location = useSelector(getLocation);
  const subpath = location?.pathname ?? "";

// we want to highlight the groups nav item if it's showing a details subpage
const isActive =
  (props.path && props.path.includes("groups") && subpath.includes(props.path)) ||
  props.path === subpath;

  return (
    <AdminNavItem
      {...props}
      active={isActive}
      style={{
        backgroundColor: isActive ? color("admin-navbar") : "transparent",
        borderRadius: "999px",
      }}
    />
  );
};
